import {axiosInstance} from "@/api/axiosInstance";

export const aiConfigService = {
    getConfig: async () => {
        const response = await axiosInstance.get(`/configuration/ai`);
        return response.data;
    },
    updateConfig: async (configDto) => {
        const response = await axiosInstance.put(`/configuration/ai`, configDto);
        return response.data;
    },
}